module.exports = {
  ipProjectData: [
    {
      img: '/static/server1.png',
      id: 1,
      title: '广发银行-科信货',
      prop: 'title'
    },
    {
      img: '/static/server2.png',
      id: 2,
      title: '兴业银行科技贷'
    },
    {
      img: '/static/server3.png',
      id: 3,
      title: '中国农业银行科技贷'
    },
    {
      img: '/static/server4.png',
      id: 4,
      title: '中国银行广东中银研发贷'
    },
    {
      img: '/static/server5.png',
      id: 5,
      title: '中国银行广东中银战疫人才贷'
    },
    {
      img: '/static/server6.png',
      id: 6,
      title: '民生银行科创信用货'
    },
    {
      img: '/static/server7.png',
      id: 16,
      title: '光大银行广州市科技货款'
    },
    {
      img: '/static/server8.png',
      id: 8,
      title: '华克银行小企业网络贷'
    },
    {
      img: '/static/server9.png',
      id: 33,
      title: '广州农商银行科技货'
    },
    {
      img: '/static/server10.png',
      id: 44,
      title: '广州农商银行援企战疫贷'
    },
    {
      img: '/static/server11.png',
      id: 12,
      title: '长沙银行科创达人贷'
    },
    {
      img: '/static/server12.png',
      id: 91,
      title: '光大银行广州市科技货款'
    }
  ]
}